import React, { Component } from 'react';
import Select from 'react-select';

import services from './data';

let CategoryOptions;
class BankList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      options: [],
    };
    this.handleChange = this.handleChange.bind(this);
  }
  componentDidMount() {
    services
      .getMappedBanks()
      .then((response) => {
        const tmp = response.data.data;
        CategoryOptions = [];
        for (let i = 0; i < tmp.length; i++) {
          CategoryOptions.push({
            value: tmp[i].bunk_bank_uuid,
            label: tmp[i].name,
          });
        }
        this.setState({ options: CategoryOptions });
      })
      .catch((error) => {
        console.log(error);
      });
  }
  handleChange = (selectedOption) => {
    let option = selectedOption;
    if (selectedOption == null) {
      option = { value: '', label: '' };
    }
    this.props.handleBankChange(option);
  };

  render() {
    const options = this.state.options;
    return (
      <Select
        onChange={this.handleChange}
        isClearable={true}
        options={options}
        className="select-box-container"
        classNamePrefix="raw-select"
        name="bank"
        placeholder="Select bank"
        value={options.filter((obj) => obj.value === this.props.value)}
        isDisabled={this.props.disabled || false}
      />
    );
  }
}

export { BankList };
